import { WidthFull } from '@mui/icons-material'
import { Typography } from '@mui/material'
import type React from 'react'
import type { ReactNode } from 'react'

// import "./CustomExplain.css";

type CustomExplainProps = {
  children: ReactNode
}

export const CustomExplain: React.FC<CustomExplainProps> = props => {
  return (
    <Typography
      sx={{
        color: '#282828',
        font: 'normal normal normal 21px/29px Noto Sans JP',
        mt: '6px',
        whiteSpace: 'pre-line',
        maxWidth: '1482px',
      }}
    >
      {props.children}
    </Typography>
  )
}
